module.exports = __webpack_public_path__ + "static/media/DubaiW23-Light.bdb3096d.woff2";